import React from 'react';
import { useTranslation } from 'react-i18next';
import { Language, getLanguageLabel } from '../i18n/languages';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const language = event.target.value as Language;
    i18n.changeLanguage(language);
  };

  const getFlag = (language: Language) => {
    switch (language) {
      case Language.ENGLISH_GB:
        return '🇬🇧';
      case Language.FINNISH:
        return '🇫🇮';
      default:
        return '🌐';
    }
  };

  return (
    <div className="language-switcher">
      <select
        onChange={changeLanguage}
        value={i18n.language}
        className="px-2 py-1 rounded border border-gray-300 text-sm"
        aria-label={getLanguageLabel(i18n.language as Language)}
        title={getLanguageLabel(i18n.language as Language)}
      >
        <option value={Language.ENGLISH_GB}>{getFlag(Language.ENGLISH_GB)}</option>
        <option value={Language.FINNISH}>{getFlag(Language.FINNISH)}</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
